import { mutationTypes } from '@helpers/storeFactories/helpers';

export default {
    async selectItem({ commit }, id) {
        commit(mutationTypes.SELECT_ITEMS, [id]);
    },
    async deselectItem({ commit }, id) {
        commit(mutationTypes.DESELECT_ITEMS, [id]);
    },
    async toggleSelectItem({ state, commit }, id) {
        const item = state.listMap[id];

        if (item) {
            if (item._selected) {
                commit(mutationTypes.DESELECT_ITEMS, [id]);
            } else {
                commit(mutationTypes.SELECT_ITEMS, [id]);
            }
        }
    },

    async toggleSelectItemSingle({ state, commit }, id) {
        const item = state.listMap[id];

        if (item) {
            if (item._selected) {
                commit(mutationTypes.DESELECT_ITEMS, [id]);
            } else {
                commit(mutationTypes.DESELECT_ALL_ITEMS);
                commit(mutationTypes.SELECT_ITEMS, [id]);
            }
        }
    },

    async selectItems({ commit }, ids) {
        commit(mutationTypes.S, ids);
    },
    async deselectItems({ commit }, ids) {
        commit(mutationTypes.SET_SELECTED, ids);
    },
    async selectAllItems({ commit }) {
        commit(mutationTypes.SELECT_ALL_ITEMS);
    },
    async deselectAllItems({ commit }) {
        commit(mutationTypes.DESELECT_ALL_ITEMS);
    },
};
